import React, { useState, useEffect } from 'react';
import '../../VendorStyles/Delivered.css';
import axiosVendorInstance from '../../axiosVendorInstance';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Loader from '../../Components/Loader/Loader';
import CloseIcon from '../../assets/svg/closeIcon';

function Delivered() {
    const [totalPages, setTotalPages] = useState(1);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orders, setOrders] = useState([]);
    const pageSize = 10;
    const [vendorID, setVendorID] = useState();
    const [totalPrice, setTotalPrice] = useState();
    const [items,setItems] = useState([]);
    
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const fetchVendorID = async () => {
        try {
            setLoading(true);
            const vendorResponse = await axiosVendorInstance.get('/vendors/account');
            const fetchedVendorID = vendorResponse?.data?.getVendorInfo[0]?.ID;
    
            if (fetchedVendorID) {
                setVendorID(fetchedVendorID);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching vendor ID:', error);
            setLoading(false);
        }
    };
    
    const fetchNewOrders = async () => {
        if (!vendorID) return;
        setLoading(true);
        try {
            const response = await axiosVendorInstance.get(
                `/Order/vendor/${vendorID}?pageSize=${pageSize}&pageNumber=${page}&statusId=6`,{skipAuth:true}
            );
           
            const incomingData = response?.data?.allOrdersDetails || [];

            if (incomingData?.length === 0 && page > 1) {
                setPage(page - 1);
            } else {
                setOrders(incomingData);
                setTotalPages(response?.data?.totalPages || 1);
            }

            setLoading(false);
        } catch (error) {
            console.error(error.message);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!vendorID) {
            fetchVendorID();
        }
    }, [vendorID]);

    useEffect(() => {
        if (vendorID) {
            fetchNewOrders();
        }
    }, [page, vendorID]);

    const handleOrderClick = (id) => {
        const selected = orders.filter((o) => o.ID === id);
        axiosVendorInstance
            .get(`/Order/user/orderinvoice/${id}`)
            .then((response) => {
           
                const selectedOrderDetails =  response?.data?.invoice[0]['0']?.Invoice_Details?.Order_Details;
                setTotalPrice(response?.data?.invoice[0]['0']?.Invoice_Details?.Total_Price);
                setItems(selectedOrderDetails);
            })
            .catch((error) => console.error('Error fetching customer data:', error));
        setSelectedOrder(selected);
        setShowPopup(true);
    };

    return (
        <div className="delivered-main">
            {loading ? (
                <Loader/>
            ) : (
                <div>
                    {orders && orders?.length > 0 ? (
                        orders?.map((order) => {
                            const createdAt = new Date(order.Created_at);
                            const time = createdAt.toLocaleTimeString('en-US', {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true,
                            });
                            const date = `${createdAt.getDate()} ${createdAt.toLocaleString(
                                'en-US',
                                { month: 'short' }
                            )}`;
                            const status =
                order.Status_id === 4 ? 'Ready to Pickup' : 'See More';

                            return (
                                <div
                                    key={order?.ID}
                                    className="delivered-single-order"
                                    onClick={() => handleOrderClick(order?.ID)}
                                >
                                    <div className="delivered-orderid">
                                        <p className="delivered-order-details1">
                      Order ID:
                                            <span className="delivered-order-id">{order?.ID}</span>
                                        </p>
                                    </div>
                                    <div className="delivered-date-and-time">
                                        <p className="delivered-order-details2">{time}</p>
                                        <p className="delivered-order-details3">{date}</p>
                                    </div>
                                    <button className="status-btn">{status}</button>{' '}
                                </div>
                            );
                        })
                    ) : (orders?.length === 0 &&
                        <div className='no-data-message'>No data</div>
                    )}

                    {showPopup && (
                        <div className="delivered-popup-container">
                            <div className="delivered-popup">
                                {selectedOrder?.map((order, index) => {
                                    const createdAt = new Date(order.Created_at);
                                    const time = createdAt.toLocaleTimeString('en-US', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: true,
                                    });
                                    const date = `${createdAt.getDate()} ${createdAt.toLocaleString(
                                        'en-US',
                                        { month: 'short' }
                                    )}`;
                                    const status =
                    order?.Status_id === 3 ? 'Declined' : 'Delivered';
                                    return (
                                        <div
                                            key={index}
                                            className="delivered-orders-single-container"
                                        >
                                            <div className="delivered-orders-single-top1">
                                                <p className="delivered-orders-order-id-text">
                          Order ID:{' '}
                                                    <span className="delivered-orders-order-id">
                                                        {order?.ID}
                                                    </span>
                                                </p>
                                                <div className="delivered-orders-order-date-and-time">
                                                    <p className="delivered-orders-order-time">{time}</p>
                                                    <p className="delivered-orders-order-date">{date}</p>
                                                </div>
                                                <CloseIcon
                                                    size={30}
                                                    color='black'
                                                    onClick={() => setShowPopup(false)}
                                                    className='close-icon'
                                                />
                                            </div>
                                            <div className="delivered-orders-dotted-line"></div>
                                            <div className="delivered-order-items-container">
                                                {items?.map((item, index) => (
                                                    <div key={index} className='delivered-order-item-row'>
                                                        <p className="delivered-order-items">
                                                            {item?.Quantity} X {item?.Menu_Item_Name}
                                                        </p>
                                                        <p className='delivered-order-items-price'>
                                                            ${item?.Menu_Item_Price * item?.Quantity}
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="delivered-orders-dotted-line"></div>
                                            <div className="delivered-order-bottom-container">
                                                <div className="delivered-order-bottom-container1">
                                                    <div className="delivered-orders-delivered-circle">
                                                        <svg
                                                            width="11"
                                                            height="9"
                                                            viewBox="0 0 11 9"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M1 4L4 7L10 1"
                                                                stroke="white"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                            />
                                                        </svg>
                                                    </div>

                                                    <p className="delivered-order-status-text">
                                                        {status}
                                                    </p>
                                                </div>
                                                <p className="delivered-order-price-text">$ {totalPrice}</p>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="new-orders-blur-background"></div>
                        </div>
                    )}

                    {orders?.length > 0 && totalPages > 1 && (
                        <div className="pagination-container">
                            <Stack spacing={2}>
                                <Pagination
                                    sx={{
                                        '& .MuiPagination-ul': {
                                            color: '#333',
                                            padding: 1,
                                            borderRadius: 2,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            listStyleType: 'none',
                                        },
                                    }}
                                    count={totalPages}
                                    page={page}
                                    onChange={handlePageChange}
                                    showFirstButton
                                    showLastButton
                                />
                            </Stack>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default Delivered;